import script from "./Faqs.vue?vue&type=script&setup=true&lang=js"
export * from "./Faqs.vue?vue&type=script&setup=true&lang=js"

import "./Faqs.vue?vue&type=style&index=0&id=a7f3454e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7f3454e"]])

export default __exports__